export interface CalculateMarginPayloadItemsProps {
  quantity: number
  price: number
  cost: number
  traderCommission: number
}

export interface CalculateMarginPayloadProps {
  items: CalculateMarginPayloadItemsProps[]
  includeIva: boolean
  discount: number
  deliveryOption: string
  totalFreightPrice: number
  financingCost?: number
  firstMileFreightCost: number
  customsFreightCost: number
  lastMileFreightCost: number
  creditGateway?: 'mercai_cash' | 'xepelin' | 'expocredito' | 'mundi'
}
export interface CalculateMarginProps {
  cm3Margin: number
  grossMargin: number
}

export interface CalculateUnitPricePayloadItemsProps
  extends CalculateMarginPayloadItemsProps {
  cm3: number | string
}

export interface CalculateUnitPricePayloadProps {
  items: CalculateUnitPricePayloadItemsProps[]
  firstMileCost: number
  customCost: number
  lastMileCost: number
  discount: number
  includeIva: boolean
  deliveryOption: string
  financingCost?: number
  totalFreightPrice: number
}

export interface CalculateLogisticCostsPayloadProps {
  items?: {
    cost: number
    quantity: number
    supplierProductUuid: string
  }[]
  originLocation?: string
  destinationAddressUuid?: string
  vehicles?: string[]
}

export interface CalculateLogisticCostsResponseProps {
  costs?: {
    firstMileCost?: number
    customsCost?: number
    lastMileCost?: number
  }
  costsMetadata?: {
    explanation: string
  }
}

export interface CalculateUnitPriceProps {
  items: {
    cm3: number
    cost: number
    quantity: number
    traderCommission: number
    unitProductPrice: number
  }[]
}

export interface GetAddressPayloadProps {
  country: 'MX' | 'US'
  postalCode: number | string
}

export interface BaseAddressProps {
  id: number
  country: string
  postalCode: string
  state: string
  city: string
  neighborhood: string
  mapsUrl?: string
}

export enum BanksEnum {
  Santander = 'Santander',
  SVB = 'SVB',
  BBVA = 'BBVA',
  STP = 'STP',
  BBase = 'BBase',
  Jeeves = 'Jeeves',
  Monex = 'Monex',
}

export interface CalculateLogisticCustomsCostsPayloadProps {
  currency?: "USD" | "MXN"
  dollarExchangeRate?: number
  includeIva?: boolean
  items?: {
    cost: number
    quantity: number
  }[]
  vehicleCapacity?: Number
}